<template>
  <svg class="stroke-current w-8 h-8 mr-1 md:mr-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36.38 36.4"><g fill="none"><path d="M21.73,28.16H.5A7.75,7.75,0,0,0,8.24,35.9H28.8A7.74,7.74,0,0,1,21.73,28.16Z"/><path d="M7.58,35.9h0Z"/><path d="M7.58.5V28.16H21.73a7.74,7.74,0,0,0,7.07,7.71,7.74,7.74,0,0,0,7.08-7.71V.5Z"/><circle cx="21.73" cy="14.28" r="5.11"/><circle cx="21.73" cy="14.28" r="2.76"/><path d="M21.73,9.56V6.42"/><path d="M21.73,22.14V19"/><path d="M26.44,14.28h3.15"/><path d="M13.87,14.28H17"/><path d="M25.06,11l2.23-2.23"/><path d="M16.17,19.84l2.22-2.22"/><path d="M25.06,17.62l2.23,2.22"/><path d="M16.17,8.72,18.39,11"/></g></svg>
</template>

<script>
export default {

};
</script>

<style>

</style>
